import { render, staticRenderFns } from "./ElementScalePayTableColumn.vue?vue&type=template&id=51eb39da&scoped=true"
import script from "./ElementScalePayTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementScalePayTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51eb39da",
  null
  
)

export default component.exports